import { keyStageOptions } from './programme-options';

import { WORKING_LEVELS } from '../types';

import { Country } from '@types';

const attainmentWorkingLevels = WORKING_LEVELS.filter(
    (level) => !level.startsWith('GCSE'),
);
const gcseWorkingLevels = WORKING_LEVELS.filter((level) =>
    level.startsWith('GCSE'),
).reverse();

const toOptions = (levels: readonly string[]) =>
    levels.map((level) => ({ id: level, name: level }));

const attainmentWorkingLevelOptions = toOptions(attainmentWorkingLevels);
const gcseWorkingLevelOptions = toOptions(gcseWorkingLevels);

export const getWorkingLevelOptions = (country: Country, yearId?: number) =>
    country === Country.GB && yearId != null && yearId >= 10
        ? gcseWorkingLevelOptions
        : attainmentWorkingLevelOptions;

export const yearGroupOptions = keyStageOptions.flatMap(
    (keyStage) => keyStage.yearGroups,
);
